import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

const url = "/api/v2/WOR/ShipToOneTimeAddressValidation";

export interface CreateShipToApiParameter extends ApiParameter {
    address1: string;
    address2: string;
    city: string;
    stateId: string;
    countryId: string;
    postalCode: string;
    oneTimeAddress: boolean;
}

export const validateOneTimeAddress = async (parameter: CreateShipToApiParameter) => {
    const response = await get<string>(url, parameter);
    return response;
};
